export const LAST_PUBLISHED = 'LAST_PUBLISHED';
export const DEFAULT_SORT_BY = LAST_PUBLISHED;
export const MOST_RELEVANT = 'Most Relevant';
export const STORE_CUPBOARD = 'STORE_CUPBOARD';
export const CORE = 'CORE';
